import React from 'react'

export const GlobalDataIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="8"
      cy="8"
      r="6"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <path
      d="M2 8h12M8 2.5c1.8 2.2 1.8 8.8 0 11M8 2.5c-1.8 2.2-1.8 8.8 0 11"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
)
